import type { JSX } from "react";
import { motion } from "framer-motion";

interface CollapseProps {
  open: boolean;
  children: React.ReactNode;
  className?: string;
  duration?: number;
}

export const Collapse = (props: CollapseProps): JSX.Element => {
  const { open, children, className, duration = 0.2 } = props;

  return (
    <motion.div
      className={className}
      style={{ overflow: "hidden", willChange: "height" }}
      initial={false}
      animate={{ height: open ? "auto" : 0 }}
      transition={{ duration, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );
};
